import React from 'react';
import Sidebar from '../Sidebar';
import Dashboard from '../Dashboard';
import MyApplicationsMain from './MyApplicationsMain'

export default function MyApplications() {
    return (
        <div>
            <Dashboard cmp={<MyApplicationsMain />} />
        </div>
    )
}

